<template>
	<footer id="footer">
		<div class="container-fluid bg-black pt-4 pt-md-5">
            <SubscribeForm></SubscribeForm>
			<div class="row justify-content-center pb-3 pt-5">
				<div class="col-lg-4 d-flex align-items-center justify-content-center">
					<button type="button" class="btn text-white fs-5 fw-600 p-1" data-bs-toggle="modal"
						data-bs-target="#contactoModal">contactos de prensa</button><span aria-hidden="true"><i
							class="fa-solid fa-chevron-right amarillo-renault"></i></span>
				</div>
			</div>
			<div class="row justify-content-center">
				<div class="col-sm-10 col-xl-9 text-center logo-redes my-5">
					<a class="nav-link h5 text-white fw-600 mb-3 d-sm-none" href="https://www.renault.com.ar/"
						target="_blank" aria-label="Web Renault Argentina">RENAULT.COM.AR</a>
					<ul>
						<li class="icon-flex">
							<a href="http://www.facebook.com/RenaultArgentina" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="Facebook Renault Argentina">
								<i class="fab fa-facebook-f"></i>
							</a>
						</li>
						<li class="icon-flex">
							<a href="http://twitter.com/RenaultArg" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="Twitter Renault Argentina">
								<i class="fab fa-twitter"></i>
							</a>
						</li>
						<li class="icon-flex">
							<a href="https://www.instagram.com/renaultarg/?hl=es" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="Instagram Renault Argentina">
								<i class="fab fa-instagram"></i>
							</a>
						</li>
						<li class="icon-flex">
							<a href="http://www.youtube.com/user/RenaultArg" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="YouTube Renault Argentina">
								<i class="fab fa-youtube"></i>
							</a>
						<li class="icon-flex">
							<a href="https://www.linkedin.com/company/renault/" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="LinkedIn Renault Global">
								<i class="fab fa-linkedin"></i>
							</a>
						</li>
                        <li class="icon-flex">
							<a href="https://www.tiktok.com/@renault" target="_blank"
								class="text-decoration-none icon-wrapper" aria-label="TikTok Renault Global">
								<i class="fab fa-tiktok"></i>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
import SubscribeForm from './SubscribeForm.vue';
export default {
  components: { SubscribeForm },
    mounted() {

    },
};
</script>